import {
  IDiscountExtendedData,
  isDiscountExtendedData,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { GeneralProviderActionsService } from '../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../transaction-action';
import { TransactionHelpers } from '../../transaction-helpers';

export class AmendDiscountTransaction
  implements ITransactionAction<IDiscountExtendedData>
{
  icon = 'edit';
  label = 'Amend';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isDiscountExtendedData;

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(
    data: ITransactionActionsData<IDiscountExtendedData>
  ): Observable<boolean> {
    return TransactionHelpers.canAmend$(data);
  }

  async do(
    data: ITransactionActionsData<IDiscountExtendedData>
  ): Promise<void> {
    this.inProgress$.next(true);
    await this._actions.amend(
      data.invoice,
      data.latestTransaction,
      'Amend Transaction'
    );
    this.inProgress$.next(false);
  }
}
